"use strict";Object.defineProperty(exports, "__esModule", {value: true});





var _DEKAT4J4cjs = require('../__chunks/DEKAT4J4.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');






exports.TabContextProvider = _DEKAT4J4cjs.TabContextProvider; exports.TabScopedContextProvider = _DEKAT4J4cjs.TabScopedContextProvider; exports.useTabContext = _DEKAT4J4cjs.useTabContext; exports.useTabProviderContext = _DEKAT4J4cjs.useTabProviderContext; exports.useTabScopedContext = _DEKAT4J4cjs.useTabScopedContext;
